import { render, staticRenderFns } from "./TheSaveModal.vue?vue&type=template&id=3049ccdc&"
import script from "./TheSaveModal.vue?vue&type=script&lang=js&"
export * from "./TheSaveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports